<script setup lang="ts">
import {
    Drawer,
    DrawerTrigger,
    DrawerContent,
    DrawerHeader,
    DrawerDescription,
    DrawerClose,
    DrawerFooter,
} from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { FormField, FormItem, FormControl, FormMessage } from '@/components/ui/form';
import { ScrollArea } from '@/components/ui/scroll-area';
import { vAutoAnimate } from '@formkit/auto-animate/vue';
import { onMounted, ref } from 'vue';
import axios from 'axios';

type ToSResponse = {
    data: {
        content: string;
    }
} | {
    message: string;
};

const termsOfService = ref<string | null>(null);
const className = "prose-hr:my-6 text-gray-800 prose-p:my-2 prose-li:list-disc"

onMounted(async () => {
    const result = await axios.get('/getToS') as ToSResponse;
    if ('data' in result) {
        const content = result.data.content;
        const emptyParagraphRegex = /<p\s?(dir="ltr")?>\s*<\/p>/ig;
        termsOfService.value = content.replace(emptyParagraphRegex, '').replace(emptyParagraphRegex, '');
    }
});
</script>

<template>
    <div class="items-top flex space-x-2">                       
        <FormField v-slot="{ value, handleChange }" type="checkbox" name="agree">
            <FormItem v-auto-animate>
                <FormControl>
                    <div class="items-top flex space-x-2">
                        <Checkbox id="agree" :checked="value" @update:checked="handleChange" />
                        <Label for="agree" class="leading-snug">
                            I confirm that I have read and agree to the terms outlined in the 
                            <Drawer>
                                <DrawerTrigger class="underline">Patient Acknowledgment and Agreement.</DrawerTrigger>
                                <DrawerContent>
                                    <ScrollArea class="h-screen">
                                        <DrawerHeader>
                                            <DrawerDescription>
                                                <div v-html="termsOfService" class="max-w-screen-md mx-auto p-2 pb-20 md:py-20 prose" :class="className" />
                                            </DrawerDescription>
                                        </DrawerHeader>
                                        <DrawerFooter class="fixed bottom-0 w-full backdrop-blur-sm bg-white/50">
                                            <DrawerClose>
                                                <Button variant="outline">Close</Button>
                                            </DrawerClose>
                                        </DrawerFooter>
                                    </ScrollArea>
                                </DrawerContent>
                            </Drawer>
                        </Label>
                    </div>
                </FormControl>
                <FormMessage />
            </FormItem>
        </FormField>
    </div>
</template>
